export default __webpack_public_path__ + "static/img-team-2-235835f9b5c856bd613b38b69b4546d7.png";